// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2444":"22caf889","7460":"4f6468e3"}[chunkId] + ".chunk.css";
};